import React from "react";
import { FaBookmark, FaPencilAlt, FaTags } from "react-icons/fa";
import TabsBar from "./TabsBar";
import styles from "./styles/MobileCategories.module.css";

const MobileCategories = ({
  variant = "default", 
  activeTab,
  setActiveTab,
  activeSubTab,
  setActiveSubTab,
  onTagClick,
}) => {
  return (
    <div className={styles.mobileActionBar}>
      {/* Scenario Categories */}
      <div className={styles.mobileTabs}>
        <TabsBar
          variant={variant}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeSubTab={activeSubTab}
          setActiveSubTab={setActiveSubTab}
        />
      </div>

    </div>
  );
};

export default MobileCategories;